import {
  documentToReactComponents
} from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document, INLINES } from '@contentful/rich-text-types';
import { theme } from '../theme';
import useIsMobile from '../hooks/useIsMobile';

const ArticleHeading2 = (node, children) => {
  return <div className='article-heading-2'>{children}</div>;
};

const ArticleHeading1 = (node, children) => {
  return <div className='article-heading-1'>{children}</div>;
};

const ArticleParagraph = (node, children) => {
  return <div className='article-paragraph'>{children}</div>;
};

const ArticleLink = ({ data }, children) => {
  return (
    <a className='article-link' href={data.uri} target='_blank' rel='noopener noreferrer'>
      {children}
    </a>
  );
};

const ArticleImage = (node, children) => {
  return <img src={`https://${node.data.target.fields.file.url}`} style={{marginBottom: '2rem', maxWidth: '100%', border: `solid ${theme.frameWidth} ${theme.frame}`}} />;
};

export default function renderRichText(documentData) {
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: ArticleParagraph,
      [BLOCKS.HEADING_2]: ArticleHeading2,
      [BLOCKS.HEADING_1]: ArticleHeading1,
      [INLINES.HYPERLINK]: ArticleLink,
      [BLOCKS.EMBEDDED_ASSET]: ArticleImage
    },
    renderText: (text) => text,
  };

  return documentToReactComponents(documentData, options);
}
